import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  createRole,
  deletePermission,
  updateRole,
} from "../../../../services/RolesServices";
import { permissionColumns } from "./utils";
import swal from "sweetalert";
import PermissionModal from "./PermissionModal";
import Loader from "../../../components/Loader";
import { useTranslation } from "react-i18next";

const RolesModal = (props) => {
  const { t } = useTranslation();
  const [trigged, setTrigged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    permission: [],
  });
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showAddPermission, setShowAddPermission] = useState(false);
  const [permissionTableData, setPermissionTableData] = useState([]);

  const onHidePermissionModal = () => {
    setShowAddPermission(false);
  };

  useEffect(() => {
    if (
      props.viewOrEdit !== "none" &&
      Object.keys(props.selectedRole).length !== 0
    ) {
      setFormValues({
        name: props.selectedRole?.name,
        description: props.selectedRole?.description,
        permission: props.selectedRole?.permission,
      });
      setTableParams((prevTableParams) => ({
        ...prevTableParams,
        total: props?.selectedRole?.permission?.length,
      }));
      setPermissionTableData(props?.selectedRole?.permission);
    }

    setLoading(false);
  }, [props.selectedRole, props.viewOrEdit]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setTrigged(true);
    setLoading(true);
    try {
      if (props.viewOrEdit === "none") {
        createRole(formValues)
          .then((res) => {
            props.getAllRoles();
            setLoading(false);
            swal(t("success"), t("role_created_successfully"), "success");
            props.setShowAddModal(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        const updateData = {
          name: formValues.name,
          description: formValues.description,
        };
        if (
          props?.selectedRole?.permission?.length < permissionTableData?.length
        ) {
          const permissionIds = props?.selectedRole?.permission?.map(
            (item) => item.id
          );

          const updatePermission = permissionTableData
            ?.filter((item) => !permissionIds.includes(item.id))
            ?.map((item) => {
              return { id: item.id };
            });
          updateData.permission = updatePermission;
        }
        updateRole(props?.selectedRole?.id, updateData)
          .then((res) => {
            props.getAllRoles();
            setLoading(false);
            swal(t("success"), t("role_updated_successfully"), "success");
            props.setShowAddModal(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const formValueController = () => {
    setFormValues({
      name: "",
      description: "",
      permission: [],
    });
    setTableParams({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    setPermissionTableData([]);
    props.onHideModal();
  };

  const deletePermissionHandler = (permissionId) => {
    try {
      deletePermission(props?.selectedRole?.id, permissionId)
        .then((res) => {
          props.getAllRoles();
          const updatedPermission = permissionTableData?.filter(
            (item) => item.id !== permissionId
          );

          setPermissionTableData(updatedPermission);
          swal(t("success"), t("role_deleted_successfully"), "success");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      className="modal fade "
      dialogClassName="modal-90w"
      size="xl"
      backdrop="static"
      show={props.showAddModal}
      onHide={props.onHideModal}
    >
      {loading && <Loader />}
      <div className="" role="document">
        <div className="">
          <form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                {props.viewOrEdit === "view"
                  ? t("view_the_role")
                  : props.viewOrEdit === "edit"
                  ? t("update_the_role")
                  : t("add_a_new_role")}
              </h4>
              <button
                type="button"
                className="close btn"
                onClick={formValueController}
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content d-flex">
                  <div className="w-50">
                    <div className={`form-group `}>
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("name")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("name_placeholder")}
                        name="name"
                        className="form-control"
                        value={formValues.name}
                        onChange={handleChange}
                        disabled={props.viewOrEdit === "view"}
                      />
                    </div>
                    {trigged && formValues.name === "" && (
                      <div className="text-danger fs-12">
                        {t("name_is_required")}
                      </div>
                    )}
                  </div>

                  <div className="w-50 ms-2">
                    <div className={`form-group `}>
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("description")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("description_placeholder")}
                        name="description"
                        className="form-control"
                        value={formValues.description}
                        onChange={handleChange}
                        disabled={props.viewOrEdit === "view"}
                      />
                    </div>
                    {trigged && formValues.description === "" && (
                      <div className="text-danger fs-12">
                        {t("description_is_required")}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4>{t("assigned_permissions")}</h4>
                  {props.viewOrEdit !== "view" && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowAddPermission(true)}
                    >
                      {t("add_permission")}
                    </button>
                  )}
                </div>
                <Table
                  columns={permissionColumns(
                    tableParams,
                    t,
                    props.viewOrEdit,
                    deletePermissionHandler
                  )}
                  rowKey={(record) => record.id}
                  dataSource={permissionTableData ?? []}
                  pagination={tableParams}
                  onChange={handleTableChange}
                />
              </div>
            </div>

            <div className="modal-footer">
              {props.viewOrEdit !== "view" && (
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={(e) => submitHandler(e)}
                >
                  {props.viewOrEdit === "edit" ? t("update") : t("add")}
                </button>
              )}
              <button
                type="reset"
                onClick={formValueController}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i>
                &nbsp;{t("discard")}
              </button>
            </div>
          </form>
        </div>
      </div>
      <PermissionModal
        formValues={formValues}
        setFormValues={setFormValues}
        showAddModal={showAddPermission}
        setShowAddPermission={setShowAddPermission}
        onHideModal={onHidePermissionModal}
        setPermissionTableData={setPermissionTableData}
      />
    </Modal>
  );
};

export default RolesModal;
